import { render, staticRenderFns } from "./VideoDynamicLayout.vue?vue&type=template&id=65251d76&scoped=true"
import script from "./VideoDynamicLayout.vue?vue&type=script&lang=js"
export * from "./VideoDynamicLayout.vue?vue&type=script&lang=js"
import style0 from "./VideoDynamicLayout.vue?vue&type=style&index=0&id=65251d76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65251d76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65251d76')) {
      api.createRecord('65251d76', component.options)
    } else {
      api.reload('65251d76', component.options)
    }
    module.hot.accept("./VideoDynamicLayout.vue?vue&type=template&id=65251d76&scoped=true", function () {
      api.rerender('65251d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/VideoDynamicLayout.vue"
export default component.exports